import type { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { orgDashboardEditVolopRoute } from 'modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardEditVolopPageContainerLoadable } from './OrgDashboardEditVolopPageContainerLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof orgDashboardEditVolopRoute>,
) {
  await OrgDashboardEditVolopPageContainerLoadable.load();
}

export default function OrgDashboardEditVolopHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <OrgDashboardEditVolopPageContainerLoadable />;
}
